import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import { primaryNav } from "@/content/site";
import { Logo } from "./Logo";
import { MobileNav } from "./MobileNav";

const MOBILE_PANEL_ID = "mobile-primary-nav";

export function SiteHeader() {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="sticky top-0 z-50"
      style={{ backgroundColor: "#0a0a0a", color: "#fff" }}
    >
      <div className="container-page flex items-center justify-between h-[88px] lg:h-[112px] gap-4">
        <Link
          to="/"
          className="no-underline focus-visible:outline-offset-4"
          aria-label="Membertou Boxing Club home"
        >
          <span className="block lg:hidden">
            <Logo size="sm" onDark />
          </span>
          <span className="hidden lg:block">
            <Logo size="md" onDark />
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden lg:block">
          <ul className="flex items-center gap-1">
            {primaryNav.map((item) => (
              <li key={item.href}>
                <NavLink
                  to={item.href}
                  end={!item.matchPrefix && item.href !== "/"}
                  className={({ isActive }) =>
                    [
                      "no-underline px-3 py-2 text-sm leading-none font-semibold uppercase tracking-wider inline-flex items-center min-h-[44px]",
                      "transition-colors",
                      isActive
                        ? "text-white border-b-2 border-brand-red"
                        : "text-white/80 border-b-2 border-transparent hover:text-white",
                    ].join(" ")
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="hidden lg:flex items-center">
          <Link to="/join" className="btn-primary text-xs px-5 py-2.5">
            Join Our Club
          </Link>
        </div>

        <button
          type="button"
          className="lg:hidden inline-flex items-center justify-center
            min-h-[52px] min-w-[52px] rounded-xl
            text-white transition-colors"
          style={{ backgroundColor: "#d71920", border: "none" }}
          aria-expanded={isMenuOpen}
          aria-controls={MOBILE_PANEL_ID}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span aria-hidden="true">
            {isMenuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 6l12 12M18 6L6 18"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 7h16M4 12h16M4 17h16"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            )}
          </span>
        </button>
      </div>

      <MobileNav
        isOpen={isMenuOpen}
        onClose={() => setMenuOpen(false)}
        panelId={MOBILE_PANEL_ID}
      />
    </header>
  );
}
